import React from "react";

const ArrowLeft = props => (
  <svg viewBox="0 0 12 20" fill="none" {...props}>
    <path
      d="M.306 9.244a1.086 1.086 0 000 1.512l8.802 8.935c.453.412 1.134.412 1.542 0l1.044-1.054c.408-.413.408-1.1 0-1.558L4.707 9.977l6.987-7.056c.408-.458.408-1.146 0-1.558L10.65.31c-.408-.412-1.089-.412-1.542 0L.306 9.244z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowLeft;
